import { render, staticRenderFns } from "./HouseFundsSelector.vue?vue&type=template&id=a2ded940&"
import script from "./HouseFundsSelector.vue?vue&type=script&lang=js&"
export * from "./HouseFundsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports